import { atom } from 'recoil';

export const baseUrlState = atom({
	key: 'baseUrlState',
	default: null,
});
